<template>
    <div class="public_container mobile_clockIn_wrap" v-loading="loading">
        <div class="returnNavBar">
            <ReturnNavBar
                title="返回"
                :isTitleNormal="true"
                :isAllFunctions="true"
                :isCustomReturnEvent="true"
                @returnEvent="handleReturnEvent"
            >
            </ReturnNavBar>
        </div>
        <div class="top_tab_wrap" :class="[topTabActive == 'SINGLE' ? 'top_tab_wrap_bg0' : 'top_tab_wrap_bg1']">
            <ul>
                <li
                    v-for="tab in topTabList"
                    :key="tab.value"
                    :class="{ active: tab.value == topTabActive }"
                    @click="handleClickTabChange(tab.value)"
                >
                    <span>{{ tab.name }}</span>
                </li>
            </ul>
            <div class="top_tab_content">
                <div class="time_wrap">
                    <h5>{{ formattedTime }}</h5>
                    <p>
                        <span>{{ getWeekday }}</span>
                        <span>{{ formattedDate }}</span>
                    </p>
                </div>
                <div class="address_wrap">
                    <p>
                        <i class="iconfont icon-weizhi1"></i>
                        <span class="ellipsis_2">{{ locationName || "定位失败" }}</span>
                    </p>
                    <p>
                        <i class="iconfont icon-shuaxin"></i>
                        <span @click="handleClickUpdateClock">更改定位</span>
                    </p>
                </div>
                <div class="btns">
                    <van-button type="info" @click="handleClickClockIn">打卡</van-button>
                </div>
            </div>
        </div>
        <div class="mobile_container">
            <div class="list_wrap" v-if="clockInRecordList.length">
                <p class="list_title">打卡记录</p>
                <ul class="list_content">
                    <li class="list_item" v-for="item in clockInRecordList" :key="item.id">
                        <template v-if="topTabActive == 'SINGLE'">
                            <div>
                                <span class="list_item_labal">时间</span><span>{{ item.punch_at }}</span>
                            </div>
                            <div>
                                <span class="list_item_labal">位置</span><span>{{ item.address }}</span>
                            </div>
                            <div v-if="item.images && item.images.length">
                                <span class="list_item_labal">照片</span>
                                <div class="item_img_wrap">
                                    <img
                                        v-for="(imgItem, imgIndex) in item.images"
                                        :key="imgIndex"
                                        :src="imgItem"
                                        alt=""
                                        @click="handleClickPreviewImg(imgIndex, item.images)"
                                    />
                                </div>
                            </div>
                            <div v-if="item.remark">
                                <span class="list_item_labal">备注</span><span>{{ item.remark }}</span>
                            </div>
                        </template>
                        <template v-else>
                            <div>
                                <span class="list_item_labal">开始时间</span
                                ><span>{{ item.start && item.start.punch_at_show }}</span>
                            </div>
                            <div>
                                <span class="list_item_labal">位置</span
                                ><span>{{ item.start && item.start.address }}</span>
                            </div>
                            <div v-if="item.start && item.start.images && item.start.images.length">
                                <span class="list_item_labal">照片</span>
                                <div class="item_img_wrap">
                                    <img
                                        v-for="(imgItem, imgIndex) in item.start.images"
                                        :key="imgIndex"
                                        :src="imgItem"
                                        alt=""
                                        @click="handleClickPreviewImg(imgIndex, item.start.images)"
                                    />
                                </div>
                            </div>
                            <div v-if="item.start && item.start.remark">
                                <span class="list_item_labal">备注</span><span>{{ item.start.remark }}</span>
                            </div>
                            <div class="split_line"></div>
                            <div v-if="item.end && !item.end.punch_at">
                                <span class="list_item_labal">已开始</span
                                ><span>{{ item.end && item.end.interval_time }}</span>
                            </div>
                            <div>
                                <span class="list_item_labal">结束时间</span>
                                <div v-if="item.end && !item.end.punch_at">
                                    <span class="link-label" @click="handleCLickInterNoNeedClock">无需打卡</span
                                    ><span>待打卡</span>
                                </div>
                                <span v-else-if="item.end && item.end.is_skip">无需打卡</span>
                                <span v-else>{{ item.end && item.end.punch_at_show }}</span>
                            </div>
                            <template v-if="item.end && item.end.punch_at && !item.end.is_skip">
                                <div>
                                    <span class="list_item_labal">位置</span
                                    ><span>{{ item.end && item.end.address_end }}</span>
                                </div>
                                <div v-if="item.end && item.end.images && item.end.images.length">
                                    <span class="list_item_labal">照片</span>
                                    <div class="item_img_wrap">
                                        <img
                                            v-for="(imgItem, imgIndex) in item.end.images"
                                            :key="imgIndex"
                                            :src="imgItem"
                                            alt=""
                                            @click="handleClickPreviewImg(imgIndex, item.end.images)"
                                        />
                                    </div>
                                </div>
                                <div v-if="item.end && item.end.remark">
                                    <span class="list_item_labal">备注</span><span>{{ item.end.remark }}</span>
                                </div>
                            </template>
                        </template>
                    </li>
                </ul>
            </div>
            <div class="mobile_no_data" v-else>
                <img src="https://download.hecoos.com/enlightv/2024-52/ca6fced677720b1c3d074bd3abafb296.png" alt="" />
                <p>未打卡~</p>
            </div>
        </div>
        <FooterTabbar :tabBarList="tabBarList" :tabBarActive="tabBarActive"></FooterTabbar>

        <!-- 打卡成功弹框 -->
        <van-popup
            v-model="clockInSuccessPopup"
            closeable
            round
            position="bottom"
            @close="handleClockInSuccessPopupClose"
            :style="{ height: '434px' }"
        >
            <div class="clockIn_success_wrap">
                <div class="clockIn_success_icon">
                    <img
                        src="https://download.hecoos.com/enlightv/2024-52/ee3c2949285252c3cf0839120c8a21d8.png"
                        alt=""
                    />
                    <p>打卡成功</p>
                </div>
                <div class="cell_group_wrap">
                    <div>
                        <div class="cell_group_label">
                            <i class="iconfont icon-messgae-clock"></i><span>开始时间</span>
                        </div>
                        <div>
                            <span>{{ clockInForm.punch_at }}</span>
                        </div>
                    </div>
                    <div>
                        <div class="cell_group_label"><i class="iconfont icon-weizhi1"></i><span>位置</span></div>
                        <div>
                            <span>{{ clockInForm.locationName }}</span>
                        </div>
                    </div>
                    <div>
                        <div class="cell_group_label"><i class="iconfont icon-tupian"></i><span>照片</span></div>
                        <div class="upload_img_wrap">
                            <div class="item_img" v-for="(imgItem, imgIndex) in clockInForm.images" :key="imgIndex">
                                <img :src="imgItem" alt="" />
                                <i class="iconfont icon-guanbi1" @click="handleClickImgDelete(imgIndex)"></i>
                            </div>
                            <div
                                class="upload_icon"
                                v-if="clockInForm.images.length < 5"
                                @click="handleClickSelectUploadType"
                            >
                                <i class="iconfont icon-xiangji"></i>
                                <!-- <input
                                    type="file"
                                    @change="handleClickUploadFile"
                                    accept="image/png,image/jpeg,image/gif,image/jpg"
                                /> -->
                            </div>
                        </div>
                    </div>
                    <div class="flex_column">
                        <div class="cell_group_label"><i class="iconfont icon-bianji"></i><span>备注</span></div>
                        <div>
                            <van-field
                                v-model="clockInForm.remark"
                                rows="3"
                                autosize
                                label=""
                                type="textarea"
                                placeholder="请输入"
                                @input="debouncedHandleInput"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
        <!-- 选择照片上传方式 -->
        <van-action-sheet v-model="imageActionSheetShow" cancel-text="取消" @cancel="handleCancelImage">
            <template #default>
                <div class="van-action-sheet__item ta-c" v-for="item in imageActions" @click="handleSelectImage(item)">
                    <span v-text="item.name"></span>
                    <input
                        type="file"
                        @change="handleClickUploadFile"
                        v-if="item.value == 1"
                        capture="camera"
                        accept="image/png,image/jpeg,image/gif,image/jpg"
                    />
                    <input
                        type="file"
                        @change="handleClickUploadFile"
                        v-if="item.value == 2"
                        accept="image/png,image/jpeg,image/gif,image/jpg"
                    />
                </div>
            </template>
        </van-action-sheet>
        <!-- 更改定位 -->
        <van-popup
            v-model="updateClockPopup"
            :overlay="false"
            position="bottom"
            :style="{ height: 'calc(100% - 44px)' }"
        >
            <div class="update_clock_popup_content">
                <p class="map_tip">可更改500米内的定位范围</p>
                <div id="mapBox" style="width: 100%; height: 383px"></div>
                <div>
                    <div class="cell_group_wrap">
                        <div>
                            <div class="cell_group_label">
                                <i class="iconfont icon-messgae-clock"></i><span>开始时间</span>
                            </div>
                            <div>
                                <span>{{ formattedTime }}</span>
                            </div>
                        </div>
                        <div>
                            <div class="cell_group_label"><i class="iconfont icon-weizhi1"></i><span>位置</span></div>
                            <div>
                                <span>{{ updateClockForm.locationName }}</span>
                            </div>
                        </div>
                        <div>
                            <div class="cell_group_label"><i class="iconfont icon-tupian"></i><span>照片</span></div>
                            <div class="upload_img_wrap">
                                <div
                                    class="item_img"
                                    v-for="(imgItem, imgIndex) in updateClockForm.images"
                                    :key="imgIndex"
                                >
                                    <img :src="imgItem" alt="" />
                                    <i class="iconfont icon-guanbi1" @click="handleClickImgDelete(imgIndex)"></i>
                                </div>
                                <div
                                    class="upload_icon"
                                    v-if="updateClockForm.images.length < 5"
                                    @click="handleClickSelectUploadType"
                                >
                                    <i class="iconfont icon-xiangji"></i>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="cell_group_label"><i class="iconfont icon-bianji"></i><span>备注</span></div>
                            <div>
                                <van-field
                                    v-model="updateClockForm.remark"
                                    label=""
                                    type="input"
                                    placeholder="请输入"
                                    input-align="right"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="update_clock_btn">
                    <van-button type="info" @click="handleClickUpdateClockSubmit">打卡</van-button>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import {
    CreateAttendanceCheck,
    GetIndividualDailyAttendanceCheck,
    UpdateAttendanceCheck,
    GetAttendanceCheckStatus,
} from "@/api";
import { getLocation, formatDate, getNowDate } from "@/utils";
import { mapState } from "vuex";
import { uploadImg } from "@/utils/uploadOss";
import { ImagePreview } from "vant";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from "@/components/mComponents/FooterTabbar.vue";
export default {
    name: "mobileClockIn",
    components: { ReturnNavBar, FooterTabbar },
    data() {
        return {
            loading: false,
            currentTime: new Date(),
            topTabActive: "SINGLE",
            topTabList: [
                { name: "单次打卡", value: "SINGLE" },
                { name: "区间打卡", value: "INTERVAL" },
            ],
            location: "116.359767,40.073051",
            locationName: "首开国风美唐综合楼-3号楼",
            // 当前打卡成功后的id，在更新数据的时候使用
            currentClockId: "",
            // 打卡记录
            clockInRecordList: [],
            // 打卡
            clockInSuccessPopup: false,
            clockInForm: {
                punch_at: "",
                locationName: "",
                remark: "",
                images: [],
            },
            updateClockForm: {
                locationName: "",
                location: "",
                is_skip: 0,
                remark: "",
                images: [],
            },
            // 更改定位
            updateClockPopup: false,
            selectedPosition: [116.397428, 39.90923],
            map: null,
            marker: null,
            // 上传图片方式
            imageActionSheetShow: false,
            imageActions: [
                { name: "拍照", value: 1 },
                { name: "从手机相册选择", value: 2 },
            ],
            // 判断区间打卡是否结束（主要是跨天打卡没法判断），true 就是都打完了  false就是上次区间打卡还没点结束
            interval_check_in_finished: false,
            tabBarActive: 0,
            tabBarList: [
                {
                    icon: "icon-daka",
                    activeIcon: "icon-daka_xuanzhong",
                    routerName: "mobileClockIn",
                    title: "打卡",
                },
                {
                    icon: "icon-dakajilu",
                    activeIcon: "icon-dakajilu_xuanzhong",
                    routerName: "mobileClockInRecord",
                    title: "打卡记录",
                },
            ],
        };
    },
    computed: {
        ...mapState(["userInfo"]),
        formattedDate() {
            const dateObj = new Date();
            // 获取年、月、日
            const year = dateObj.getFullYear();
            const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
            const day = ("0" + dateObj.getDate()).slice(-2);
            return year + "." + month + "." + day;
        },
        formattedTime() {
            return formatDate(this.currentTime, "hourtime");
        },
        getWeekday() {
            const days = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
            const date = new Date();
            return days[date.getDay()];
        },
    },
    created() {
        this.debouncedHandleInput = this.debounce(this.handleInput, 500);
        this.getCurrentPosition();
        this.getIndividualDailyAttendanceCheck();
        this.getAttendanceCheckStatus();
    },
    mounted() {
        this.timer = setInterval(() => {
            this.currentTime = new Date();
        }, 1000);
    },
    methods: {
        // 返回操作
        handleReturnEvent() {
            if (this.updateClockPopup) {
                this.updateClockPopup = false;
            } else {
                if (this.$router.history.length <= 1) {
                    // 没有上一页，跳转到固定页面
                    this.$router.push({ name: "mobileAllFunctions" });
                } else {
                    // 有上一页，后退
                    this.$router.go(-1);
                }
            }
        },
        // 顶部tab切换
        handleClickTabChange(topTabActive) {
            this.topTabActive = topTabActive;
            this.$nextTick(() => {
                this.getIndividualDailyAttendanceCheck();
            });
        },
        // 备注输入回调
        handleInput(event) {
            this.handleUpdateAttendanceCheck();
        },
        // 防抖
        debounce(func, wait) {
            let timeout;
            return function (...args) {
                const later = () => {
                    timeout = null;
                    func.apply(this, args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        },
        handleClockInSuccessPopupClose() {
            this.clockInSuccessPopup = false;
            this.clockInForm.images = [];
            this.clockInForm.remark = "";
            this.getIndividualDailyAttendanceCheck();
        },
        // 选择上传图片方式
        handleClickSelectUploadType() {
            this.imageActionSheetShow = true;
        },
        // 选择上传图片
        handleSelectImage(item) {},
        handleCancelImage() {},
        // 预览图片
        handleClickPreviewImg(index, images) {
            ImagePreview({
                images,
                startPosition: index,
            });
        },
        // 删除图片
        handleClickImgDelete(index) {
            if (this.updateClockPopup) {
                this.updateClockForm.images.splice(index, 1);
            } else {
                this.clockInForm.images.splice(index, 1);
                this.$nextTick(() => {
                    this.handleUpdateAttendanceCheck();
                });
            }
        },
        // 上传照片
        handleClickUploadFile(e) {
            e.preventDefault();
            this.imageActionSheetShow = false;
            let that = this;
            const file = e.target.files[0];
            if (file) {
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function () {
                    const _data = this.result;
                    let blob = that.dataURItoBlob(_data);
                    let file = new window.File([blob], "照片.jpg", { type: "image/jpeg" });

                    uploadImg(file)
                        .then((res) => {
                            if (that.updateClockPopup) {
                                // 更改定位弹框
                                that.updateClockForm.images.push(res.file_path);
                            } else {
                                that.clockInForm.images.push(res.file_path);
                                that.$nextTick(() => {
                                    that.handleUpdateAttendanceCheck();
                                });
                            }
                        })
                        .catch(() => {});
                };
            }
        },
        // base64转换为Blob
        dataURItoBlob(base64Data) {
            let byteString;
            if (base64Data.split(",")[0].indexOf("base64") >= 0) {
                byteString = atob(base64Data.split(",")[1]);
            } else {
                byteString = unescape(base64Data.split(",")[1]);
            }
            let mimeString = base64Data.split(",")[0].split(":")[1].split(";")[0];
            let ia = new Uint8Array(byteString.length);
            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ia], { type: mimeString });
        },
        // 初始化地理位置
        getCurrentPosition() {
            let that = this;
            AMap.plugin("AMap.Geolocation", function () {
                var geolocation = new AMap.Geolocation({
                    enableHighAccuracy: true, //是否使用高精度定位，默认:true
                    timeout: 100000, //超过10秒后停止定位，默认：无穷大
                    buttonOffset: new AMap.Pixel(1, 2), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                    zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
                });
                // map.addControl(geolocation);
                geolocation.getCurrentPosition(function (status, result) {
                    if (status === "complete") {
                        that.onComplete(result);
                    } else {
                        that.onError(result);
                    }
                });
            });
        },
        onComplete(data) {
            // 定位成功回调函数
            let lng = data.position.lng;
            let lat = data.position.lat;
            this.selectedPosition = [lng, lat];
            this.location = this.selectedPosition.join(",");
            this.convertToAddress(lng, lat).then((res) => {
                this.locationName = res;
                if (this.updateClockPopup) {
                    this.updateClockForm.locationName = this.locationName;
                }
            });
        },
        // 初始化地图
        async initMap() {
            // 初始化地图
            this.map = new AMap.Map("mapBox", {
                resizeEnable: true,
                zoom: 18, // 缩放级别
                center: this.selectedPosition || [116.397428, 39.90923], // 默认中心点（北京）
            });
            let that = this;
            // 获取用户当前位置
            AMap.plugin("AMap.Geolocation", function () {
                var geolocation = new AMap.Geolocation({
                    enableHighAccuracy: true, //是否使用高精度定位，默认:true
                    timeout: 100000, //超过10秒后停止定位，默认：无穷大
                    buttonOffset: new AMap.Pixel(1, 2), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                    zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
                });
                // map.addControl(geolocation);
                geolocation.getCurrentPosition(function (status, result) {
                    if (status === "complete") {
                        that.onComplete(result);
                    } else {
                        that.onError(result);
                    }

                    setTimeout(() => {
                        that.marker = new AMap.Marker({
                            position: that.selectedPosition,
                            map: that.map,
                            draggable: true, // 允许拖拽
                        });

                        // 监听标记拖拽事件
                        that.marker.on("dragend", (event) => {
                            console.log(event, "event===");
                            const { lng, lat } = event.lnglat;
                            that.selectedPosition = [lng, lat];
                            that.updateClockForm.location = this.selectedPosition.join(",");
                            that.onComplete({ position: { lng, lat } });
                        });
                    });
                });
            });
        },
        // 获取当前定位位置
        onError(result) {
            this.$toast("定位当前位置失败");
        },
        // 将经纬度转换为详细的地址
        async convertToAddress(longitude, latitude) {
            try {
                //这里的key修改为自己申请的key
                var response = await fetch(
                    `https://restapi.amap.com/v3/geocode/regeo?key=fc197e0057f33f3d1c6cfb50f33b9e3d&location=${longitude},${latitude}`
                );
                var data = await response.json();
                // 返回详细地址方法
                // if (data && data.regeocode && data.regeocode.formatted_address) {
                //     return data.regeocode.formatted_address; // 返回具体地址
                // } else {
                //     return "地址获取失败";
                // }
                // 返回指定信息
                if (data && data.regeocode && data.regeocode.addressComponent) {
                    const addressComponentInfo = data.regeocode.addressComponent;
                    // ${addressComponentInfo.district}
                    return `${addressComponentInfo.township}${
                        addressComponentInfo.streetNumber && addressComponentInfo.streetNumber.street
                    }${addressComponentInfo.streetNumber && addressComponentInfo.streetNumber.number}`;
                } else {
                    return "地址获取失败";
                }
            } catch (error) {
                return "地址获取发生错误";
            }
        },
        // 更改定位
        handleClickUpdateClock() {
            this.updateClockForm.location = this.selectedPosition.join(",");
            this.updateClockPopup = true;
            this.$nextTick(() => {
                this.initMap();
            });
        },
        // 判断区间打卡当前是否结束
        getAttendanceCheckStatus() {
            GetAttendanceCheckStatus().then((res) => {
                if (res.code === 200) {
                    this.interval_check_in_finished = res.data.interval_check-in_finished;
                }
            });
        },
        // 直接打卡
        async handleClickClockIn() {
            // try {
            //     const location = await getLocation();
            //     this.location = location;
            //     console.log(location)
            // } catch (err) {
            //     const error = this.parseError(err);
            //     this.$toast(error)
            // } finally {
            //     this.loading = false;
            // }

            let params = {
                punch_type: this.topTabActive,
                location: this.location,
                address: this.locationName,
                is_skip: 0,
                remark: [],
                images: [],
            };
            if (this.topTabActive === "INTERVAL") {
                // 只有结束打卡的时候需要传address_end
                if (this.clockInRecordList.length) {
                    const latestData = this.clockInRecordList[0];
                    const is_finish = latestData.end.is_finish;
                    if (!is_finish) {
                        // 当前操作的是区间结束打卡
                        params.address_end = params.address;
                    }
                } else if(!this.interval_check_in_finished){
                    // 还没点结束打卡
                    params.address_end = params.address;
                }
            }
            this.clockInForm.punch_at = this.formattedTime;
            this.clockInForm.locationName = this.locationName;
            CreateAttendanceCheck(params).then((res) => {
                if (res.code == 200) {
                    this.currentClockId = res.data.id;
                    this.clockInSuccessPopup = true;
                }
            });
        },
        parseError(error) {
            switch (error.code) {
                case error.PERMISSION_DENIED:
                    return "用户拒绝了定位请求";
                case error.POSITION_UNAVAILABLE:
                    return "无法获取位置信息";
                case error.TIMEOUT:
                    return "定位超时";
                default:
                    return "定位失败";
            }
        },
        // 更新本次打卡记录数据
        handleUpdateAttendanceCheck() {
            const params = {
                id: this.currentClockId,
                remark: this.clockInForm.remark ? [this.clockInForm.remark] : [],
                images: this.clockInForm.images,
            };
            UpdateAttendanceCheck(params).then((res) => {
                if (res.code === 200) {
                    // this.$toast(res.message);
                    // this.getIndividualDailyAttendanceCheck()
                }
            });
        },
        // 更改定位提交打卡
        handleClickUpdateClockSubmit() {
            let params = {
                punch_type: this.topTabActive,
                location: this.updateClockForm.location,
                address: this.updateClockForm.locationName,
                is_skip: this.updateClockForm.is_skip,
                remark: this.updateClockForm.remark ? [this.updateClockForm.remark] : [],
                images: this.updateClockForm.images,
            };
            console.log(params, "params===");
            CreateAttendanceCheck(params).then((res) => {
                if (res.code == 200) {
                    this.$toast("打卡成功");
                    this.updateClockPopup = false;
                    this.getIndividualDailyAttendanceCheck();
                }
            });
        },
        // 区间打卡无需打卡
        handleCLickInterNoNeedClock() {
            let params = {
                punch_type: this.topTabActive,
                location: this.location,
                is_skip: 1, // 是否是无需打卡 1是、0否，默认为0
                remark: [],
                images: [],
            };
            CreateAttendanceCheck(params).then((res) => {
                if (res.code == 200) {
                    this.$toast("无需打卡成功");
                    this.getIndividualDailyAttendanceCheck();
                }
            });
        },
        // 获取打卡记录
        getIndividualDailyAttendanceCheck() {
            GetIndividualDailyAttendanceCheck({
                company_id: this.userInfo.user.company_id,
                uid: this.userInfo.user.id,
                calc_date: getNowDate(),
                page_source: "PUNCH_PAGE",
                punch_type: this.topTabActive,
            }).then((res) => {
                if (res.code === 200) {
                    this.clockInRecordList = res.data.map((item) => {
                        if (this.topTabActive == "SINGLE") {
                            return {
                                ...item,
                                punch_at:
                                    this.topTabActive == "SINGLE"
                                        ? formatDate(item.punch_at, "hourtime")
                                        : item.punch_at,
                            };
                        } else {
                            return item;
                        }
                    });
                }
            });
        },
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
};
</script>

<style lang="scss" scoped>
.mobile_clockIn_wrap {
    background-color: rgba(247, 248, 250, 1);
    .top_tab_wrap {
        margin: 16px 16px 0;
        height: 221px;
        background-color: rgba(153, 153, 153, 0.05);
        border-radius: 15px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        position: relative;
        &::before {
            content: "";
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 0;
            background-repeat: no-repeat;
            background-size: 100% 100%;
        }
        &.top_tab_wrap_bg0 {
            &::before {
                background-image: url("https://download.hecoos.com/enlightv/2024-52/bd94df3ac54783a6c2dc2bb79d4a7e13.png");
            }
        }
        &.top_tab_wrap_bg1 {
            &::before {
                background-image: url("https://download.hecoos.com/enlightv/2024-52/4033b34d4a23f506e7b1a3d0607bbd9d.png");
            }
        }
        ul {
            flex-wrap: nowrap;
            height: 40px;
            display: flex;
            li {
                flex: 1;
                padding-top: 10px;
                text-align: center;
                position: relative;
                span {
                    font-size: 14px;
                    font-weight: 700;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(153, 153, 153, 1);
                }
                &.active {
                    span {
                        font-size: 16px;
                        font-weight: 700;
                        letter-spacing: 0px;
                        line-height: 24px;
                        color: rgba(41, 144, 255, 1);
                    }
                    &::after {
                        content: "";
                        position: absolute;
                        left: 50%;
                        transform: translateX(-50%);
                        bottom: 0;
                        width: 32px;
                        height: 2px;
                        opacity: 1;
                        border-radius: 20px;
                        background: rgba(41, 144, 255, 1);
                    }
                }
            }
        }
        .top_tab_content {
            height: 181px;
            padding: 12px 16px 0;
            box-sizing: border-box;
            background-color: #ffffff;
            z-index: 1;
            flex: 1;
            .time_wrap {
                width: 100%;
                display: flex;
                justify-content: space-between;
                gap: 20px;
                h5 {
                    font-size: 36px;
                    font-weight: 700;
                    letter-spacing: 0px;
                    height: 48px;
                    line-height: 52px;
                    color: rgba(0, 0, 0, 1);
                }
                p:nth-child(2) {
                    padding: 2px 0;
                    span {
                        display: block;
                        font-size: 14px;
                        font-weight: 500;
                        letter-spacing: 0px;
                        line-height: 22px;
                        color: rgba(153, 153, 153, 1);
                        text-align: right;
                    }
                }
            }
            .address_wrap {
                margin-top: 20px;
                height: 20px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                p:nth-child(1) {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    color: rgba(51, 51, 51, 1);
                    .iconfont {
                        font-size: 20px;
                    }
                    span {
                        font-size: 14px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 22px;
                    }
                }
                p:nth-child(2) {
                    flex-shrink: 0;
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    color: rgba(41, 144, 240, 1);
                    .iconfont {
                        font-size: 12px;
                    }
                    span {
                        font-size: 14px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 22px;
                    }
                }
            }
            .btns {
                margin: 20px auto 0;
                text-align: center;
                .van-button {
                    width: 112px;
                    height: 38px;
                    border-radius: 8px;
                    font-size: 16px;
                    font-weight: 700;
                    background-color: rgba(41, 144, 255, 0.8);
                    border: none;
                    &:active {
                        background-color: rgba(41, 144, 255, 0.6);
                    }
                }
            }
        }
    }
    .mobile_container {
        padding: 0 16px;
        .mobile_no_data {
            padding: 46px 0;
            text-align: center;
            img {
                width: 250px;
                margin: 0 auto;
            }
            p {
                margin-top: -40px;
                font-size: 16px;
                font-weight: 500;
                letter-spacing: 0px;
                line-height: 24px;
                color: rgba(41, 144, 255, 0.6);
            }
        }
        .list_wrap {
            .list_title {
                padding: 6px;
                font-size: 14px;
                font-weight: 500;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(153, 153, 153, 1);
            }
            .list_content {
            }
            .list_item {
                border-radius: 5px;
                padding: 12px 10px;
                margin-bottom: 12px;
                background-color: #ffffff;
                & > div {
                    display: flex;
                    justify-content: space-between;
                    &:not(:last-child) {
                        margin-bottom: 12px;
                    }
                    .list_item_labal {
                        flex-shrink: 0;
                        width: 58px;
                        font-size: 14px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 22px;
                        color: rgba(102, 102, 102, 1);
                    }
                    & > span:last-child,
                    & > div {
                        flex: 1;
                        text-align: right;
                        font-size: 14px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 22px;
                        color: rgba(102, 102, 102, 1);
                    }
                }
                .item_img_wrap {
                    display: flex;
                    justify-content: flex-end;
                    gap: 10px;
                    img {
                        width: 30px;
                        height: 30px;
                        object-fit: contain;
                    }
                }
                .split_line {
                    width: 100%;
                    height: 1px;
                    position: relative;
                    &::after {
                        content: "";
                        position: absolute;
                        left: -10px;
                        right: -10px;
                        bottom: 0;
                        height: 1px;
                        background: rgba(243, 243, 243, 1);
                    }
                }
                .link-label {
                    margin-right: 12px;
                }
            }
        }
    }
}
.clockIn_success_wrap {
    width: 100%;
    height: 100%;
    border-radius: 8px 8px, 0px, 0px;
    background: rgba(250, 250, 250, 1);
    box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.08);
    padding: 30px 16px 10px;
    .clockIn_success_icon {
        text-align: center;
        img {
            width: 74px;
            height: auto;
        }
        p {
            margin-top: 14px;
            font-size: 16px;
            font-weight: 700;
            letter-spacing: 0px;
            line-height: 24px;
            color: rgba(51, 51, 51, 1);
        }
    }
}
.cell_group_wrap {
    margin-top: 14px;
    border-radius: 8px;
    background-color: #ffffff;
    & > div {
        padding: 12px 10px;
        border-bottom: 1px solid rgba(250, 250, 250, 1);
        display: flex;
        justify-content: space-between;
        gap: 12px;
        span {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(102, 102, 102, 1);
        }
        .cell_group_label {
            flex-shrink: 0;
            display: flex;
            align-items: center;
            gap: 6px;
            .iconfont {
                font-size: 16px;
            }
        }
    }
    .flex_column {
        flex-direction: column;
        gap: 0;
        .van-cell {
            padding: 12px 0 0 20px;
            ::v-deep {
                textarea {
                    height: 66px !important;
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(102, 102, 102, 1);
                }
            }
        }
    }
    .upload_img_wrap {
        display: flex;
        gap: 10px;
        .item_img_wrap {
            width: 30px;
            height: 30px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .upload_icon {
            position: relative;
            width: 30px;
            height: 30px;
            opacity: 1;
            border-radius: 4px;
            background: rgba(247, 248, 250, 1);
            display: flex;
            justify-content: center;
            align-items: center;
            .iconfont {
                color: rgba(102, 102, 102, 1);
                font-size: 16px;
            }
            input {
                position: absolute;
                width: 100%;
                height: 100%;
                opacity: 0;
                left: 0;
                top: 0;
                right: 0;
                bottom: 0;
            }
        }
        .item_img {
            width: 30px;
            height: 30px;
            position: relative;
            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
            .iconfont {
                position: absolute;
                top: -5px;
                right: -5px;
                font-size: 16px;
                color: rgba(153, 153, 153, 1);
                background-color: #ffffff;
                border-radius: 50%;
            }
        }
    }
}
.van-action-sheet__item {
    position: relative;
    input {
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
    }
}
.update_clock_popup_content {
    padding: 0 20px;
    .map_tip {
        padding: 0 0 10px 0;
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        text-align: center;
        line-height: 18px;
        color: rgba(153, 153, 153, 1);
    }
    .cell_group_wrap {
        & > div {
            padding: 12px 0;
        }
        ::v-deep {
            .van-cell {
                padding: 0;
            }
        }
    }
    .update_clock_btn {
        padding: 10px 0;
        .van-button {
            width: 100%;
            height: 38px;
            border-radius: 8px;
            background: rgba(25, 144, 255, 1);
        }
    }
}
</style>
<style lang="scss">
.van-image-preview__overlay {
    background: rgba(0, 0, 0, 0.3);
}
.van-image-preview {
    .van-image-preview__index {
        top: auto;
        bottom: 26px !important;
        text-shadow: none;
    }
}
</style>
